import { useState } from 'react';
import useWebData from '../../hooks/useWebData';
import BookingReferenceForm from './BookingReferenceForm';
import ReservationDetails from './ReservationDetails';
import { getReservationsOfReferece } from '../../services/myBooking';
import WarningAlert from '../../components/WarningAlert';
import usePleaseWait from '../../hooks/usePleaseWait';
import { tenantId } from '../../config/api';

const MyBooking = () => {  
  const { webData }: any = useWebData();
  const { setPleasWaitPopup }: any = usePleaseWait();
  const [email, setEmail] = useState<string>("");
  const [bookingNumber, setBookingNumber] = useState<string>("");
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [reservationDetailsOfBookingNumber, setReservationDetailsOfBookingNumber] = useState<any>(null);
  const [isReponseSuccessfully, setIsReponseSuccessfully] = useState<boolean>(false);

  document.title = webData?.companyName + " | My Booking";

  const handlSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!isProcessing) {
      setPleasWaitPopup(true);
      setIsProcessing(true);

      getReservationsOfReferece(bookingNumber?.trim(), email?.trim(), tenantId)
        .then(data => {
          setIsReponseSuccessfully(false);
          setReservationDetailsOfBookingNumber({
            ...data,
          });

          setIsProcessing(false);
          setPleasWaitPopup(false);
          setEmail("");
          setBookingNumber("");

        })
        .catch(error => {
          setIsReponseSuccessfully(true);
          setPleasWaitPopup(false);
          setIsProcessing(false);
          setEmail("");
          setBookingNumber("");
          console.error(error);
        })
    }
  }


  return (
    <div className='mt-[130px] '>
      <section
        style={{ backgroundImage: `url('${webData?.websiteSubPageImage ? webData?.websiteSubPageImage : ""}')` }}
        className="relative my-booking-container flex flex-col justify-center w-full h-[200px] bg-no-repeat bg-cover bg-center">
        <div className="absolute inset-0 bg-black bg-opacity-40" />
        <div className='w-full text-center absolute'>
          <h1 className="text-center text-white text-2xl font-bold">MANAGE BOOKING</h1>
          <p className="text-center text-white text-sm sm:text-md md:text-xl">View the details for your reservation.</p>
        </div>

      </section>

      {isReponseSuccessfully &&
        <div className="flex justify-center mt-8 -mb-8">
          <WarningAlert text="Please check your Email and Reference Id" />
        </div>
      }

      {(reservationDetailsOfBookingNumber === null || reservationDetailsOfBookingNumber === undefined) ?
        <BookingReferenceForm
          email={email}
          setEmail={setEmail}
          bookingNumber={bookingNumber}
          setBookingNumber={setBookingNumber}
          handlSubmit={handlSubmit}
          isProcessing={isProcessing}
        />
        :
        <ReservationDetails reservationDetailsOfBookingNumber={reservationDetailsOfBookingNumber} />
      }

    </div>
  )
}

export default MyBooking